import React from 'react';

const clients = require("./images/clients.jpg");

const WhoWeWork = () => {
    return (
        <section className="relative max-w-screen-xl mx-auto py-4 px-4 md:px-8">
            <div className="absolute top-0 left-0 w-full h-full bg-white opacity-40"></div>
            <div className="relative z-10 gap-5 items-center lg:flex">
                <div className="flex-1 max-w-lg py-5 sm:mx-auto sm:text-center lg:max-w-max lg:text-left">
                    <h3 className="text-3xl text-gray-800 font-semibold md:text-4xl">
                        Who We Work With? <span className="text-indigo-600">For Developers & Property Managers</span>
                    </h3>
                    
                          <div className="space-y-2 text-gray-700 text-md mt-4">
        <p>- residential developers</p>
        <p>- property management companies</p>
        <p>- large-scale communities</p>
        <p>- resort-style developments</p>
        <h3 className='y-4 text-xl font-semibold'>Our systems are designed for projects where service quality and operational efficiency are critical.</h3>
      </div>

                    <a
                        className="mt-5 px-4 py-2 text-indigo-600 font-medium bg-indigo-50 rounded-full inline-flex items-center"
                        href="#leadform">
                        Request a Consultation
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 ml-1 duration-150" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                        </svg>
                    </a>
                </div>
                <div className="flex-1 mt-5 mx-auto sm:w-9/12 lg:mt-0 lg:w-auto">
                    <img 
                        src={clients} 
                        alt="Our clients" 
                        className="w-full border rounded-xl shadow-2xl" 
                    />
                </div>
            </div>
        </section>
    )
}

export default WhoWeWork;
